import { render } from "./GenericText.vue?vue&type=template&id=686e9ba1"
import script from "./GenericText.vue?vue&type=script&lang=js"
export * from "./GenericText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__